import { ViewStream } from "spyne";
import { AppDataTraits } from "traits/app-data-traits";
import { NavigationTraits } from "traits/navigation-traits";
import { UIHeaderView } from 'components/ui/ui-header-view';

export class UIMenuDrawer extends ViewStream {
  constructor(props = {}) {
    props.id = "menu-drawer";
    props.class = "menu-drawer hide";
    props.traits = [NavigationTraits];
    props.data3 = props.data.linksData;
    props.data2 = AppDataTraits.api$GetNavLinks();
    props.data = UIHeaderView.mainMenuLinks();
    props.data.pageLinks = props.data.pageLinks.filter(v=>v.pageId!=='reference');

    const updateDataForMobile = ()=>{


      const addSectionToBlogMapFn = (o)=>{
        if (o.pageId==='blog'){
          o.section = 'frontend-architecture-has-met-its-reasoning-moment';
          o.href="blog/frontend-architecture-has-met-its-reasoning-moment";
        }
        return o;
      }


      props.data.pageLinks = props.data.pageLinks.map(addSectionToBlogMapFn)



      props.data.pageLinks.push({
        "pageId": "plans",
        "title": "Plans",
        "endRoute": "true",
        "href": "/plans",
        "navLevel": 1
      })




    }


    updateDataForMobile();

    props.template = require("./templates/ui-menu-drawer.tmpl.html");
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [
      ["CHANNEL_ROUTE_.*EVENT", "onRouteChangeEvent"],
      ["CHANNEL_MENU_DRAWER_.*_EVENT", "onShowMenuDrawerEvent"],
    ];
  }

  onRouteChangeEvent(e) {
    const { routeData } = e.payload;
    if (routeData === undefined) {
      return;
    }
    let { pageId, cardId } = routeData;
    //const cardIdIsEmpty = cardId === undefined || cardId === null || cardId === '';
    const cardSel = cardId ? `[data-card-id='${cardId}']` : "";
    const anchorSel = "a.menu-drawer-link";
    const activeSel = `${anchorSel}[data-page-id='${pageId}']${cardSel}`;

    //console.log("active selector ", {activeSel, pageId, cardId, cardSel})

    this.props.el$('a').setActiveItem('selected', activeSel);
  }

  onShowMenuDrawerEvent(e) {
    const { action } = e;
    const showDrawer = action === "CHANNEL_MENU_DRAWER_SHOW_EVENT";
    this.props.el$.toggleClass("open", showDrawer);
    this.nav$HideNav(!showDrawer);
  }

  broadcastEvents() {
    // return nexted array(s)
    return [["a", "click"]];
  }

  onRendered() {

    const blogLink = this.props.el$('[data-page-id="blog"]');
    if (blogLink.exists){
      blogLink.el.dataset['section'] = "frontend-architecture-has-met-its-reasoning-moment";
    }

    this.addChannel("CHANNEL_MENU_DRAWER");
    this.addChannel("CHANNEL_ROUTE");
  }
}
